<template>
    <!-- 配置-抽成配置-司机抽成-订单模式编辑 -->

    <el-drawer
        title="司机抽成订单模式配置"
        :visible.sync="show"
        :before-close="closeDialog"
        append-to-body
        size="80%"
        class="order-detial-wrap"
        :show-close="false"
        destroy-on-close
    >
        <div class="container pay" v-loading="loading">
            <div>
                <div>订单模式:</div>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllEditChild" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0"></div>
                <el-checkbox-group v-model="checkedModesEditChild" @change="handleCheckedModesChange">
                    <el-checkbox v-for="(item, index) in modeAllEditChild" :label="item.order_mode.order_mode_code" :key="index">{{
                        item.name
                    }}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>

        <div style="display: flex; justify-content: center; margin-top: 20px">
            <el-button @click="closeDialog">关闭</el-button>
            <el-button @click="digSubmit" type="primary">保存</el-button>
        </div>
    </el-drawer>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: Array, // 选择的订单模式
        changeIndex_children: '', // 订单模式编辑按钮的index
        checkboxSelect_children: '' // 全职，兼职或者按单的区分标记
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.checkedModesEditChild = _this.data; // this.checkedModesEditChild订单模式复选框v-model绑定值
            // console.log(_this.checkedModesEditChild, '_this.checkedModesEditChild-----------');
            // console.log(_this.changeIndex_children,'changeIndex_children订单模式编辑按钮的index');
            // console.log(_this.checkboxSelect_children,'changeIndex全职，兼职或者按单的区分标记');
            // _this.modeAllEditChild = _this.orderModeAll;
            // _this.checkboxSelect_child = _this.checkboxSelect;
            _this.orderModeList(); // 获取订单模式
        }
    },

    data() {
        return {
            loading: false,
            // checkboxSelect_children: '',
            show: false,
            checkAllEditChild: false,

            checkedModesEditChild: [], // 订单模式复选框v-model绑定值，勾选的订单模式
            modeAllEditChild: [], // 全部的订单模式数组

            isIndeterminate: true,
            part_order_mode_code_array: [], //订单模式编码
            single_order_mode_code_array: [], //订单模式编码

            // 订单模式查询条件
            mode_options_data_child: {
                page: 1,
                limit: 50,
                status: ''
            },

            submit_rules: {
                part_order_mode_code_array: {
                    placeholder: '订单模式',
                    rules: {
                        required: true,
                        message: '请选择订单模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                single_order_mode_code_array: {
                    placeholder: '订单模式',
                    rules: {
                        required: true,
                        message: '请选择订单模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 保存
        digSubmit() {
            // console.log(_this.checkedModesEditChild,'选择的订单模式');

            // changeIndex_children
            // console.log(this.$parent, 'this.$parent');
            if (_this.checkboxSelect_children == 'full') {
                // 全职 修改父组件的值

                // this.$emit('modifySyncFull', this.checkedModesEditChild,this.changeIndex_children);

                // bus.$emit('modifySyncFull', this.checkedModesEditChild);
                this.$parent.full_synchronization_children[this.changeIndex_children].full_order_mode_code_array = this.checkedModesEditChild; // this.checkedModesEditChild是选择的订单模式
            }
            if (_this.checkboxSelect_children == 'part') {
                // 兼职
                // this.$emit('modifySyncPart', this.checkedModesEditChild,this.changeIndex_children);

                this.$parent.part_synchronization_children[this.changeIndex_children].part_order_mode_code_array = this.checkedModesEditChild;
            }
            if (_this.checkboxSelect_children == 'single') {
                // 按单
                // this.$emit('modifySyncSingle', this.checkedModesEditChild,this.changeIndex_children);

                this.$parent.single_synchronization_children[this.changeIndex_children].single_order_mode_code_array = this.checkedModesEditChild;
            }
            if (_this.checkboxSelect_children == 'fullThird') {
                // 全职 修改父组件的值

                // this.$emit('modifySyncFull', this.checkedModesEditChild,this.changeIndex_children);

                // bus.$emit('modifySyncFull', this.checkedModesEditChild);
                this.$parent.fullData.synchronization[this.changeIndex_children].order_mode_code_array = this.checkedModesEditChild; // this.checkedModesEditChild是选择的订单模式
            }
            if (_this.checkboxSelect_children == 'partThird') {
                // 全职 修改父组件的值

                // this.$emit('modifySyncFull', this.checkedModesEditChild,this.changeIndex_children);

                // bus.$emit('modifySyncFull', this.checkedModesEditChild);
                this.$parent.partData.synchronization[this.changeIndex_children].order_mode_code_array = this.checkedModesEditChild; // this.checkedModesEditChild是选择的订单模式
            }
            if (_this.checkboxSelect_children == 'singleThird') {
                // 全职 修改父组件的值

                // this.$emit('modifySyncFull', this.checkedModesEditChild,this.changeIndex_children);

                // bus.$emit('modifySyncFull', this.checkedModesEditChild);
                this.$parent.singleData.synchronization[this.changeIndex_children].order_mode_code_array = this.checkedModesEditChild; // this.checkedModesEditChild是选择的订单模式
            }

            this.closeDialog(); // 保存数据后关闭当前页面
        },

        // 全选按钮方法
        handleCheckAllChange(val) {
            // console.log(_this.modeAllEditChild.length, '_this.modeAllEditChild');
            // console.log(this.checkedModesEditChild = val,'val');
            // this.checkedModesEditChild = val ? _this.modeAllEditChild : [];
            // console.log(this.$refs.editMode,'this.$refs');
            if (val) {
                // 如果勾选全选按钮
                let codeArray = [];

                for (let i = 0; i < _this.modeAllEditChild.length; i++) {
                    codeArray.push(_this.modeAllEditChild[i].order_mode.order_mode_code);
                }

                this.checkedModesEditChild = codeArray; // this.checkedModesEditChild订单模式复选框v-model绑定值
            } else {
                // 取消全选按钮勾选
                this.checkedModesEditChild = []; // this.checkedModesEditChild订单模式复选框v-model绑定值
            }

            this.isIndeterminate = false;
        },

        // 订单模式复选框change方法
        handleCheckedModesChange(value) {
            let checkedCount = value.length;
            this.checkAllEditChild = checkedCount === this.modeAllEditChild.length;

            // 至少勾选一个订单模式，并且没有全部勾选
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.modeAllEditChild.length;
            // console.log(this.$refs.editModeE,'this.$refs');
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            // console.log(_this.show,'_this.show');
        },

        //获取订单模式
        orderModeList() {
            _this.loading = true;
            _this.modeAllEditChild = [];
            _this.getMode();
            // _this
            //     .$post('/order/orderModeLists', _this.mode_options_data_child)
            //     .then((res) => {
            //         _this.modeAllEditChild = res.data;
            //         // console.log(_this.modeAllEditChild,'_this.modeAllEditChild');

            //         if (_this.checkedModesEditChild.length == this.modeAllEditChild.length) {
            //             _this.checkAllEditChild = true;
            //             _this.isIndeterminate = false;

            //         }
            //     })
            //     .catch((err) => {});
        },
        getMode() {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data_child)
                .then((res) => {
                    // _this.options_order_code = res.data;
                    for (var i = 0; i < res.data.length; i++) {
                        _this.modeAllEditChild.push(res.data[i]);
                    }
                    // console.log(_this.mode_options_data_child.page * _this.mode_options_data_child.limit < res.count, '--');

                    if (_this.mode_options_data_child.page * _this.mode_options_data_child.limit < res.count) {
                        _this.mode_options_data_child.page += 1;
                        _this.getMode();
                    } else {
                        _this.mode_options_data_child.page = 1;
                    }

                    if (_this.checkedModesEditChild.length == this.modeAllEditChild.length) {
                        _this.checkAllEditChild = true;
                        _this.isIndeterminate = false;
                    }
                    // console.log(_this.modeAllEditChild, '_this.modeAllEditChild');
                    _this.loading = false;
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
</style>






